<template>
  <div>
    <div
      v-for="(product, index) in products"
      :key="index"
      class="dot"
      :style="`top:${product.y}%;left:${product.x}%;
      display:${isShow(index)};
      background-color:${dotColor(product.isInside)}`"
    />
  </div>
</template>

<script>
export default {
  name: 'Dotlist',
  props: {
    products: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      currentShowIndex: 0,
    };
  },
  created() {
    window.setInterval(() => {
      this.currentShowIndex += 1;
    }, 3000);
  },
  methods: {
    isShow(index) {
      if (this.currentShowIndex >= this.products.length) {
        this.currentShowIndex = 0;
      }
      return this.currentShowIndex === index ? 'block' : 'none';
    },
    dotColor(isInside) {
      return isInside ? 'red' : 'blue';
    },
  },
};
</script>

<style lang="scss" scoped>
.dot {
  position: absolute;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  background-color: red;
  opacity: 0.5;
  animation: dot-scale 1.5s ease 0s infinite;
}

@keyframes dot-scale {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
}
</style>
